import React from 'react';

const NoDataFound = ({ message = "No data found", subMessage = "Get started by adding new items" }) => (
  <div className="flex flex-col items-center justify-center p-8 text-center">
    <svg 
      className="w-40 h-40 text-gray-300 mb-4" 
      viewBox="0 0 100 100" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M50 10C28.95 10 12 26.95 12 48C12 69.05 28.95 86 50 86C71.05 86 88 69.05 88 48C88 26.95 71.05 10 50 10ZM50 78C33.45 78 20 64.55 20 48C20 31.45 33.45 18 50 18C66.55 18 80 31.45 80 48C80 64.55 66.55 78 50 78Z" fill="currentColor"/>
      <path d="M50 30C47.8 30 46 31.8 46 34V50C46 51.1 46.45 52.15 47.3 52.85L59.3 62.85C60.55 63.85 62.35 63.65 63.35 62.4C64.35 61.15 64.15 59.35 62.9 58.35L52 49.15V34C52 31.8 50.2 30 50 30Z" fill="currentColor"/>
    </svg>
    <h3 className="text-xl font-semibold text-gray-600">{message}</h3>
    <p className="text-gray-500 mt-2">{subMessage}</p>
  </div>
);

export default NoDataFound;